import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';
import SkeletonV3 from './skeleton-v3';
import { useMemo } from 'react';

const DynamicCarouselBannerV4 = dynamic(() => import('./carousel'), {
  ssr: false,
  loading: (props: any) => <Skeleton version="v4" {...props} />
});

const DynamicCarouselBanner = dynamic(() => import('./carousel'), {
  ssr: false,
  loading: (props: any) => <Skeleton {...props} />
});
const DynamicCarouselBannerV3 = dynamic(() => import('./carousel-v3'), {
  ssr: false,
  loading: SkeletonV3
});

const CarouselBanner = props => {
  const { properties } = props;
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });
  const isV3Banner = properties?.version === 'v3';
  const isV4Banner = properties?.version === 'v4';

  const skeleton = isV3Banner ? <SkeletonV3 /> : <Skeleton version={properties?.version} {...props} />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  if (isV3Banner) {
    return <DynamicCarouselBannerV3 skeleton={skeleton} {...props} />;
  }
  if (isV4Banner) {
    return <DynamicCarouselBannerV4 skeleton={skeleton} {...props} />;
  }
  return <DynamicCarouselBanner skeleton={skeleton} {...props} />;
};

export default CarouselBanner;
